/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropbox_Wrong_EnvironmentInputs */

const en_dropbox_wrong_environment = /** @type {(inputs: Dropbox_Wrong_EnvironmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use an app build that matches the selected backend to connect Dropbox.`)
};

const es_dropbox_wrong_environment = /** @type {(inputs: Dropbox_Wrong_EnvironmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa una versión de la app que corresponda al servidor seleccionado para conectar Dropbox.`)
};

/**
* | output |
* | --- |
* | "Use an app build that matches the selected backend to connect Dropbox." |
*
* @param {Dropbox_Wrong_EnvironmentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dropbox_wrong_environment = /** @type {((inputs?: Dropbox_Wrong_EnvironmentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropbox_Wrong_EnvironmentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dropbox_wrong_environment(inputs)
	return en_dropbox_wrong_environment(inputs)
});